export const QueryKeys = {
  MyCollaborationInvites: "my-collaboration-invites",
  Group: "group",
}